import { WEARAppIconWithoutBorder } from '~/components/icons/generated/WEARAppIconWithoutBorder'

type Props = {
  href?: string
  target?: string
  rel?: string
  onButtonClick: () => void
  onCloseClick: () => void
  title: string
  message: React.ReactNode
  buttonText: string
}
export const AppLeadingDialog: React.FC<Props> = ({
  onButtonClick,
  onCloseClick,
  href,
  target,
  rel,
  title,
  message,
  buttonText,
}) => {
  return (
    <div className="relative flex flex-col items-center bg-white py-9">
      <WEARAppIconWithoutBorder
        width={72}
        height={72}
        className="drop-shadow-[0_0_5px_rgba(0,0,0,0.1)]"
      />
      <p className="whitespace-pre-wrap pt-5 text-center text-[18px] font-bold leading-normal">
        {title}
      </p>
      <p className="whitespace-pre-wrap pb-[19px] pt-[5px] text-center text-[12px] leading-normal text-gray-600">
        {message}
      </p>
      {href ? (
        <a
          href={href}
          target={target}
          rel={rel}
          onClick={onButtonClick}
          className="flex h-10 w-[200px] items-center justify-center rounded-full bg-blue-500 text-center text-[14px] font-bold text-white"
        >
          {buttonText}
        </a>
      ) : (
        <button
          onClick={onButtonClick}
          type="button"
          className="flex h-10 w-[200px] items-center justify-center rounded-full bg-blue-500 text-center text-[14px] font-bold text-white"
        >
          {buttonText}
        </button>
      )}
      <button
        onClick={onCloseClick}
        className="absolute right-3 top-3 flex"
        type="button"
      >
        <svg
          aria-label="閉じる"
          viewBox="0 0 32 32"
          width={32}
          height={32}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.6667 16.3333C29.6667 23.6971 23.6971 29.6667 16.3333 29.6667C8.96954 29.6667 3 23.6971 3 16.3333C3 8.96954 8.96954 3 16.3333 3C23.6971 3 29.6667 8.96954 29.6667 16.3333Z"
            fill="#2D2D2D"
            fillOpacity="0.4"
          />
          <path
            d="M16.3267 3C13.688 3 11.1159 3.78667 8.91704 5.25333C6.73147 6.72 5.01233 8.8 4.01283 11.24C3 13.6667 2.74679 16.3467 3.25321 18.9333C3.77295 21.52 5.03898 23.8933 6.90471 25.76C8.77045 27.6267 11.1426 28.8933 13.728 29.4133C16.3133 29.9333 18.992 29.6667 21.4308 28.6533C23.8696 27.64 25.9485 25.9333 27.4145 23.7467C28.8804 21.56 29.6667 18.9733 29.6667 16.3333C29.6667 12.8 28.2674 9.4 25.762 6.90667C23.2565 4.4 19.8716 3 16.34 3H16.3267ZM21.0843 21.0933C20.7111 21.4667 20.1114 21.4667 19.7383 21.0933L16.3267 17.68L12.915 21.0933C12.5419 21.4667 11.9422 21.4667 11.569 21.0933C11.1959 20.72 11.1959 20.12 11.569 19.7467L14.9807 16.3333L11.569 12.92C11.1959 12.5467 11.1959 11.9467 11.569 11.5733C11.9422 11.2 12.5419 11.2 12.915 11.5733L16.3267 14.9867L19.7383 11.5733C20.1114 11.2 20.7111 11.2 21.0843 11.5733C21.4574 11.9467 21.4574 12.5467 21.0843 12.92L17.6727 16.3333L21.0843 19.7467C21.4574 20.12 21.4574 20.72 21.0843 21.0933Z"
            fill="#EDEDED"
          />
        </svg>
      </button>
    </div>
  )
}
